<template>
    <keep-alive :exclude='destroyComponent'>
        <component :is="currentComponentName"></component>
    </keep-alive>
</template>

<script>
import Index from '../components/Index'
import Login from '../components/Login'
export default  {
  name:  'App',
  components: { Index, Login},
  data() {
      return {
           currentComponentName: null,
           destroyComponent: 'Index'
      }
  },
  mounted() {
      if(this.security.isLogin()) {
          this.currentComponentName = 'Index';
      } else{
          this.currentComponentName = 'Login';
      }
      // 监听登录成功事件
      this.$bus.$on(this.dict.event.LOGIN_SUCCESS, () => {
          window.history.pushState({}, 0, '/');
          this.currentComponentName = 'Index';
      });
       // 监听退出事件
      this.$bus.$on(this.dict.event.LOGOUT, () => {
          this.currentComponentName = 'Login';
      });
  }

}
</script>



// WEBPACK FOOTER //
// src/components/App.vue